import { render, staticRenderFns } from "./JourneyOverview.vue?vue&type=template&id=7ed8006c&scoped=true&"
import script from "./JourneyOverview.vue?vue&type=script&lang=js&"
export * from "./JourneyOverview.vue?vue&type=script&lang=js&"
import style0 from "./JourneyOverview.vue?vue&type=style&index=0&id=7ed8006c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed8006c",
  null
  
)

export default component.exports